import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Stack
} from '@mui/material';
import { WarningAmber, Send } from '@mui/icons-material';

const AlertaModal = ({ open, onClose, mensagem, setMensagem, onEnviar }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Stack direction="row" spacing={1} alignItems="center">
          <WarningAmber color="warning" />
          <Typography variant="h6">Enviar Alerta Personalizado</Typography>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="textSecondary" mb={2}>
          Escreva uma mensagem de alerta que será enviada para os responsáveis dos kids selecionados.
        </Typography>
        <TextField
          fullWidth
          multiline
          autoFocus
          rows={4}
          value={mensagem}
          onChange={(e) => setMensagem(e.target.value)}
          placeholder="Digite aqui a mensagem do alerta..."
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={onEnviar}
          startIcon={<Send />}
        >
          Enviar Alerta
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertaModal;
